import { api } from './baseApi'
export type Maybe<T> = T | null
export type InputMaybe<T> = Maybe<T>
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] }
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> }
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> }
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string
  String: string
  Boolean: boolean
  Int: number
  Float: number
  /** The `JSONObject` scalar type represents JSON objects as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSONObject: any
  _Any: any
}

export type Analytics = {
  __typename?: 'Analytics'
  googleTagManager?: Maybe<Array<Maybe<GoogleTagManager>>>
}

export type Branding = {
  __typename?: 'Branding'
  name: Scalars['ID']
  themeUrls?: Maybe<ThemeUrls>
}

export type ClientConfig = {
  __typename?: 'ClientConfig'
  clientSlug: Scalars['ID']
  frontendEnvironment: FrontendEnvironment
  healthCircle?: Maybe<HealthCircle>
  healthJourney?: Maybe<HealthJourney>
  providerSearch?: Maybe<ProviderSearch>
  scheduling?: Maybe<Scheduling>
}

export type Cta = {
  __typename?: 'Cta'
  icon?: Maybe<Icon>
  text?: Maybe<Scalars['String']>
  url?: Maybe<Scalars['String']>
}

export enum ErrorType {
  AuthenticationError = 'AuthenticationError',
  ForbiddenError = 'ForbiddenError',
  SyntaxError = 'SyntaxError',
  UnknownError = 'UnknownError',
  UserInputError = 'UserInputError',
  ValidationError = 'ValidationError',
}

export enum Filter {
  AcceptingNew = 'acceptingNew',
  Age = 'age',
  Availability = 'availability',
  Distance = 'distance',
  Gender = 'gender',
  Insurance = 'insurance',
  Languages = 'languages',
}

export type Fonts = {
  __typename?: 'Fonts'
  black?: Maybe<Scalars['String']>
  blackItalic?: Maybe<Scalars['String']>
  body?: Maybe<Scalars['String']>
  bold?: Maybe<Scalars['String']>
  boldItalic?: Maybe<Scalars['String']>
  hairline?: Maybe<Scalars['String']>
  heading?: Maybe<Scalars['String']>
  light?: Maybe<Scalars['String']>
  lightItalic?: Maybe<Scalars['String']>
  regular?: Maybe<Scalars['String']>
  regularItalic?: Maybe<Scalars['String']>
}

export type FrontendEnvironment = {
  __typename?: 'FrontendEnvironment'
  analytics?: Maybe<Analytics>
  appPortal: Scalars['String']
  theme: Theme
}

export type GoogleTagManager = {
  __typename?: 'GoogleTagManager'
  dataLayerName?: Maybe<Scalars['String']>
  eventMap?: Maybe<Array<Maybe<StringMapEntry>>>
  gaKey: Scalars['String']
}

export type HealthCircle = {
  __typename?: 'HealthCircle'
  entryCta?: Maybe<Cta>
}

export type HealthJourney = {
  __typename?: 'HealthJourney'
  entryCta?: Maybe<Cta>
}

export enum Icon {
  Ambulance = 'ambulance',
  Bandaid = 'bandaid',
  Calendar = 'calendar',
  CommunicationChathealt = 'communicationChathealt',
  Lightbulb = 'lightbulb',
  Magnifier = 'magnifier',
  PeopleHealthTribe = 'peopleHealthTribe',
  SpecialtyCare = 'specialtyCare',
  Stethoscope = 'stethoscope',
  Virus = 'virus',
}

/** Simple type for constructing a integer map entry */
export type IntMapEntry = {
  __typename?: 'IntMapEntry'
  key: Scalars['String']
  value: Scalars['Int']
}

export enum JsType {
  Boolean = 'boolean',
  Number = 'number',
  String = 'string',
}

export type Option = {
  __typename?: 'Option'
  id: Scalars['ID']
  nextQuestion?: Maybe<Question>
  text: Scalars['String']
  value: Scalars['String']
}

export type Palette = {
  __typename?: 'Palette'
  accentBase?: Maybe<Scalars['String']>
  active?: Maybe<Scalars['String']>
  black?: Maybe<Scalars['String']>
  blackish?: Maybe<Scalars['String']>
  bluish?: Maybe<Scalars['String']>
  brand?: Maybe<Scalars['String']>
  greenish?: Maybe<Scalars['String']>
  greys?: Maybe<Array<Maybe<Scalars['String']>>>
  indigoish?: Maybe<Scalars['String']>
  orangish?: Maybe<Scalars['String']>
  overlay?: Maybe<Scalars['String']>
  primaryActive?: Maybe<Scalars['String']>
  primaryBase?: Maybe<Scalars['String']>
  primaryBaseLg?: Maybe<Scalars['String']>
  primaryLight?: Maybe<Scalars['String']>
  redish?: Maybe<Scalars['String']>
  secondary?: Maybe<Scalars['String']>
  violetish?: Maybe<Scalars['String']>
  white?: Maybe<Scalars['String']>
  whitish?: Maybe<Scalars['String']>
  yellowish?: Maybe<Scalars['String']>
}

/** ProviderSearch configurations */
export type ProviderSearch = {
  __typename?: 'ProviderSearch'
  doctorCardClientLogo?: Maybe<Scalars['String']>
  entryCta: Cta
  headingText: Scalars['String']
  pageTitle: Scalars['String']
  preferredProviderGroupId?: Maybe<Scalars['String']>
  pssClient: PssClient
  pssClientMrcFlow?: Maybe<PssClient>
  searchCta: Cta
  showGetMedicalRecordsButton: Scalars['Boolean']
  subHeadingText: Scalars['String']
  typeahead: Typeahead
}

/** Client identifier for PSS queries. See Client type in PSS schema */
export type PssClient = {
  __typename?: 'PssClient'
  config?: Maybe<Scalars['String']>
  data_sets?: Maybe<Array<Maybe<Scalars['String']>>>
  id?: Maybe<Scalars['String']>
  name?: Maybe<Scalars['String']>
}

export type Query = {
  __typename?: 'Query'
  _entities: Array<Maybe<_Entity>>
  _service: _Service
  branding?: Maybe<Branding>
  clientConfig?: Maybe<ClientConfig>
  clientConfigs?: Maybe<Array<Maybe<ClientConfig>>>
  echo?: Maybe<Scalars['String']>
  simulateError?: Maybe<Scalars['String']>
  theme?: Maybe<Theme>
}

export type Query_EntitiesArgs = {
  representations: Array<Scalars['_Any']>
}

export type QueryBrandingArgs = {
  name: Scalars['ID']
}

export type QueryClientConfigArgs = {
  clientSlug?: InputMaybe<Scalars['ID']>
}

export type QueryEchoArgs = {
  input?: InputMaybe<Scalars['String']>
}

export type QuerySimulateErrorArgs = {
  error?: InputMaybe<ErrorType>
}

export type QueryThemeArgs = {
  name: Scalars['ID']
}

export type Question = {
  __typename?: 'Question'
  id: Scalars['ID']
  isRootQuestion: Scalars['Boolean']
  optionType: JsType
  options: Array<Maybe<Option>>
  text: Scalars['String']
}

export type Scheduling = {
  __typename?: 'Scheduling'
  eligibilityQuestions?: Maybe<Array<Maybe<Question>>>
  entryCta?: Maybe<Cta>
}

export type SchedulingEligibilityQuestionsArgs = {
  flatten?: InputMaybe<Scalars['Boolean']>
}

export enum Sort {
  Availability = 'availability',
  Distance = 'distance',
  Relevance = 'relevance',
}

/** Simple type for constructing a string map entry */
export type StringMapEntry = {
  __typename?: 'StringMapEntry'
  key: Scalars['String']
  value: Scalars['String']
}

/**
 * See https://theme-ui.com/theming for more info on
 * the base theme specification. End user client libs
 * should consume this to create a specific theme based
 * on this spec, e.g., ui-toolkit should consume this to
 * produce the MUI Theme.
 */
export type Theme = {
  __typename?: 'Theme'
  breakpoints?: Maybe<Array<Maybe<Scalars['String']>>>
  colors?: Maybe<Palette>
  fontSizes?: Maybe<Array<Maybe<Scalars['Int']>>>
  fontWeights?: Maybe<Scalars['JSONObject']>
  lineHeights?: Maybe<Scalars['JSONObject']>
  space?: Maybe<Array<Maybe<Scalars['Int']>>>
  styles?: Maybe<Scalars['JSONObject']>
}

export type ThemeUrls = {
  __typename?: 'ThemeUrls'
  favicon?: Maybe<Scalars['String']>
  fonts?: Maybe<Fonts>
  icon?: Maybe<Scalars['String']>
  iconDark?: Maybe<Scalars['String']>
  logo?: Maybe<Scalars['String']>
  logoDark?: Maybe<Scalars['String']>
  store_icon?: Maybe<Scalars['String']>
}

export type Typeahead = {
  __typename?: 'Typeahead'
  helpText?: Maybe<Scalars['String']>
  profile?: Maybe<TypeaheadProfile>
}

export enum TypeaheadProfile {
  Default = 'default',
  GroupByType = 'groupByType',
}

export type _Entity = Branding | ClientConfig

export type _Service = {
  __typename?: '_Service'
  /** The sdl representing the federated service capabilities. Includes federation directives, removes federation types, and includes rest of full schema after schema directives have been applied */
  sdl?: Maybe<Scalars['String']>
}

export type GetThemeAndBrandingAssetsQueryVariables = Exact<{
  name: Scalars['ID']
}>

export type GetThemeAndBrandingAssetsQuery = {
  __typename?: 'Query'
  branding?:
    | {
        __typename?: 'Branding'
        themeUrls?:
          | {
              __typename?: 'ThemeUrls'
              logo?: string | null | undefined
              logoDark?: string | null | undefined
              favicon?: string | null | undefined
              fonts?:
                | {
                    __typename?: 'Fonts'
                    regular?: string | null | undefined
                    regularItalic?: string | null | undefined
                    bold?: string | null | undefined
                    boldItalic?: string | null | undefined
                  }
                | null
                | undefined
            }
          | null
          | undefined
      }
    | null
    | undefined
  theme?:
    | {
        __typename?: 'Theme'
        space?: Array<number | null | undefined> | null | undefined
        breakpoints?: Array<string | null | undefined> | null | undefined
        fontWeights?: any | null | undefined
        colors?:
          | {
              __typename?: 'Palette'
              primaryActive?: string | null | undefined
              primaryBase?: string | null | undefined
              primaryBaseLg?: string | null | undefined
              primaryLight?: string | null | undefined
              secondary?: string | null | undefined
              accentBase?: string | null | undefined
              active?: string | null | undefined
              overlay?: string | null | undefined
              brand?: string | null | undefined
              redish?: string | null | undefined
              orangish?: string | null | undefined
              yellowish?: string | null | undefined
              greenish?: string | null | undefined
              bluish?: string | null | undefined
              indigoish?: string | null | undefined
              violetish?: string | null | undefined
              blackish?: string | null | undefined
              whitish?: string | null | undefined
              white?: string | null | undefined
              black?: string | null | undefined
              greys?: Array<string | null | undefined> | null | undefined
            }
          | null
          | undefined
      }
    | null
    | undefined
}

export const GetThemeAndBrandingAssetsDocument = `
    query GetThemeAndBrandingAssets($name: ID!) {
  branding(name: $name) {
    themeUrls {
      logo
      logoDark
      favicon
      fonts {
        regular
        regularItalic
        bold
        boldItalic
      }
    }
  }
  theme(name: $name) {
    colors {
      primaryActive
      primaryBase
      primaryBaseLg
      primaryLight
      secondary
      accentBase
      active
      overlay
      brand
      redish
      orangish
      yellowish
      greenish
      bluish
      indigoish
      violetish
      blackish
      whitish
      white
      black
      greys
    }
    space
    breakpoints
    fontWeights
  }
}
    `

const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    GetThemeAndBrandingAssets: build.query<GetThemeAndBrandingAssetsQuery, GetThemeAndBrandingAssetsQueryVariables>({
      query: (variables) => ({ document: GetThemeAndBrandingAssetsDocument, variables }),
    }),
  }),
})

export { injectedRtkApi as api }
export const { useGetThemeAndBrandingAssetsQuery, useLazyGetThemeAndBrandingAssetsQuery } = injectedRtkApi
